import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { callHistoryQueryKeys } from './queryKeys';

const getOperators = async () => {
  const res = await request.get('/Phone/operators', {}, '', []);
  return res;
};

const useOperators = (options) =>
  useQuery(callHistoryQueryKeys.operators(), getOperators, options);

export default useOperators;
